<template>
    <div class="headerPage">
        <div ref="asss" class="flex header_left">
            <a href="/home/index" class="decoration_box">
                <img class="header_logo" src="../../public/platformLogo.png" />
            </a>
            <div class="fold_icon">
                <i v-show="!isFold && $route.path != '/home/index'" class="el-icon-s-fold" @click="handleFoldMenus(true)"></i>
                <i v-show="isFold && $route.path != '/home/index'" class="el-icon-s-unfold" @click="handleFoldMenus(false)"></i>
            </div>
        </div>
        <div class="header_right">
            <img class="header_logo" src="../../public/logo2.png" />
            <i :class="{ msgIcon: 1, 'el-icon-message-solid': 1, msgHot: msgSum > 0 && 0 }"></i>
            <!-- <el-dropdown @command="noticeDetail">
                <i :class="{ msgIcon: 1, 'el-icon-message-solid': 1, msgHot: msgSum > 0 && 0 }"></i>
                <el-dropdown-menu size="small" slot="dropdown">
                    <el-dropdown-item :command="index" v-for="(item, index) in msgTypeData" :key="index"
                        ><span>{{ item.label }}：{{ item.msgDataLength }}</span></el-dropdown-item
                    >
                </el-dropdown-menu>
            </el-dropdown> -->
            <div class="userinfo">
                <el-dropdown trigger="click">
                    <div class="nickname">{{ userInfoData.nickName }}</div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="clearfix" @click.native="showCenterDialog">个人中心</el-dropdown-item>
                        <el-dropdown-item class="clearfix" @click.native="handleLogOut">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-dialog title="个人中心" width="800px" :visible.sync="centerDialogVisible" center>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="个人信息" name="first"></el-tab-pane>
                <el-tab-pane label="修改密码" name="second"></el-tab-pane>
            </el-tabs>
            <template v-if="activeName == 'first'">
                <el-form ref="form" :model="userForm" :rules="rules" label-width="80px">
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="用户昵称" prop="nickName">
                                <el-input v-model="userForm.nickName" disabled placeholder="请输入用户昵称" maxlength="30" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :offset="1">
                            <el-form-item label="邮箱" prop="email">
                                <el-input v-model="userForm.email" placeholder="请输入邮箱" maxlength="50" @blur="submitEmail" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="手机号码" prop="phoneNumber">
                                <el-input v-model="userForm.phoneNumber" disabled placeholder="请输入手机号码" maxlength="11" @blur="checkPhoneNumber" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :offset="1">
                            <el-form-item label="租户城市">
                                <el-select v-model="areaForm.areaCode" :disabled="userForm.userType != '20'" placeholder="请选择城市" filterable clearable @change="submitCity">
                                    <el-option v-for="item in provinceAreaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="性别">
                                <el-select v-model="userForm.sex" disabled placeholder="请选择性别" clearable>
                                    <el-option label="男" value="0" />
                                    <el-option label="女" value="1" />
                                    <el-option label="未知" value="2" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :offset="1">
                            <el-form-item label="租户名称"><el-input v-model="areaForm.tenantName" disabled placeholder="" maxlength="50" /> </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- tenantName -->
                <!-- <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitForm">确 定</el-button>
                    <el-button @click="cancel">取 消</el-button>
                </div> -->
            </template>
            <template v-if="activeName == 'second'">
                <el-form @keyup.enter.native="handleLogin" ref="form" :model="form">
                    <el-form-item label="原始密码">
                        <el-input v-model="form.oldPassword" placeholder="请输入原始密码" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码">
                        <el-input v-model="form.newPassword" placeholder="请输入新密码" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="重复新密码">
                        <el-input v-model="form.newPassword2" placeholder="请重复输入新密码" type="password"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="centerDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleEditPassword">确 定</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog class="policeDialog" title="警情处理" width="900px" :visible.sync="policeVisible" :close-on-press-escape="false" :close-on-click-modal="false" center @close="closePolice">
            <div style="margin-bottom: 20px; margin-top: -20px">
                <span>设备号：{{ warningData.device_number ? warningData.device_number : '--' }}</span>
                <span style="margin-left: 20px; color: red">紧急告警</span>
            </div>
            <div class="policeBox clearfix">
                <div class="box_left fl" v-for="(item, index) in videoList" :key="index">
                    <streaming-media-player :ref="'mediaHeaderRef' + index" :mediaPlayerData="item" :hideCloseBtn="true" :mediaIndex="index" @sreamEnd="sreamEnd" @sreamStart="sreamStart" @clearPlayTime="clearPlayTime"></streaming-media-player>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeWarning">确认警情</el-button>
            </span>
        </el-dialog>
        <div class="product-update" v-if="showProductFlag">
            <p class="productTitle">更新亮点</p>
            <div class="product-box">
                <div class="list">
                    <img src="../../public/images/home/product1.png" />
                    <p>新增车辆行程批量下载功能</p>
                </div>
                <div class="list">
                    <img src="../../public/images/home/product2.png" />
                    <p>全新升级“运营数据大屏”</p>
                </div>
                <div class="list">
                    <img src="../../public/images/home/product3.png" />
                    <p>新增车辆管理、统计分析模块</p>
                </div>
            </div>
            <i class="el-icon-circle-close closeBtn" @click="closeProduct"></i>
        </div>
    </div>
</template>

<script>
import StreamingMediaPlayer from './StreamingMediaPlayer.vue';
import { baseURL } from '@/api/index.js';
import { buildMenuTrackingPayload } from '../utils/menuTracking';
export default {
    name: 'MyHeader',
    props: {
        msg: String,
        checkedMenu: Object
    },
    components: {
        StreamingMediaPlayer
    },
    data() {
        return {
            isFold: false,
            activeName: 'first',
            form: {
                oldPassword: '',
                newPassword: '',
                newPassword2: ''
            },
            centerDialogVisible: false,
            menus: [],
            menusObj: [],
            activeMenuId: '',
            policeVisible: false,
            countdown1: null,
            countdown2: null,
            videoList: [
                {
                    name: 'xxx视频',
                    url: 'xxxxx.live.flv',
                    poster: 'xxx.jpg',
                    hideVideoFlag: false,
                    autoPlay: true
                },
                {
                    name: 'xxx视频',
                    url: 'xxxxx.live.flv',
                    poster: 'xxx.jpg',
                    hideVideoFlag: false,
                    autoPlay: true
                }
            ],
            msgTypeData: [
                { label: '镜头遮挡', value: 'lensOcclusion', key: 0 },
                { label: '疲劳驾驶', value: 'fatigueDriving', key: 1 },
                { label: '前向碰撞', value: 'forwardCollision', key: 2 }
            ],
            warningList: [],
            warningData: {},
            currentDeviceNumber: null,
            openDialogFlag: null,
            pageStatus: 1,
            warningObj: {},
            msgSum: 0,
            userForm: {
                userId: null,
                deptId: null,
                userName: null,
                nickName: null,
                password: null,
                phoneNumber: null,
                email: null,
                sex: null,
                status: '0',
                remark: null,
                postIdList: [],
                roleIdList: []
            },
            form: {
                oldPassword: null,
                newPassword: null,
                newPassword2: null
            },
            areaForm: {
                areaCode: null,
                tenantId: null,
                tenantName: null
            },
            roleOptions: [],
            rules: {},
            provinceAreaOptions: [],
            showProductFlag: false
        };
    },
    methods: {
        queryUserProduct() {
            this.$request({
                method: 'post',
                url: '/ubi/api/dict/byCurrentUserFirstMark',
                data: {}
            }).then((res) => {
                if (res.code == 200 && !res.data) {
                    this.showProductFlag = true;
                }
            });
        },
        closeProduct() {
            this.showProductFlag = false;
        },
        submitEmail() {
            const emailRegAdvanced = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;
            if (!emailRegAdvanced.test(this.userForm.email)) {
                this.$message.error('请检查邮箱格式！');
                return;
            }
            this.$request({
                method: 'post',
                url: '/upms/api/user/updateCurrentUserInfo',
                data: this.userForm
            }).then((res) => {
                if (res.code == 200) {
                    this.$message.success('修改成功！');
                    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                    userInfo.email = this.userForm.email;
                    localStorage.setItem('userInfo', JSON.stringify(userInfo));
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        submitCity(val) {
            if (!val) {
                return;
            }
            this.$request({
                method: 'post',
                url: '/upms/api/tenant/editArea',
                data: this.areaForm
            }).then((res) => {
                if (res.code == 200) {
                    this.$message.success('修改成功！');
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        showCenterDialog() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.userForm = userInfo;
            this.queryCurrentAre();
            this.provinceAreaOptions.length < 1 && this.findProvinceArea();
        },
        queryCurrentAre() {
            this.$request({
                method: 'get',
                url: '/ubi/api/tenant/currentTenantArea',
                params: {}
            }).then((res) => {
                this.centerDialogVisible = true;
                if (res.code == 200) {
                    this.areaForm = res.data;
                    this.areaForm.id = res.data.tenantId;
                }
            });
        },
        findProvinceArea() {
            this.$request({
                method: 'get',
                url: '/ubi/api/tenant/findProvinceArea',
                params: {}
            }).then((res) => {
                if (res.code == 200) {
                    this.provinceAreaOptions = res.data;
                }
            });
        },
        submitForm() {},
        cancel() {},
        checkPhoneNumber() {
            // this.instance.post('/upms/api/user/findPhoneNum', { phoneNumber: this.form.phoneNumber }).then((res) => {
            //     let data = res.data;
            //     if (data.code == 200 && data.data > 0) {
            //         this.$message.error(`请注意当前手机号已创建 ${data.data} 个帐号！`);
            //     }
            // });
        },
        handleClick() {
            // if (this.activeName === 'second' && this.BDmap && this.center.lng && this.center.lat) {
            //     setTimeout(() => {
            //         this.BDmap.setCenter(new this.BMap.Point(this.center.lng, this.center.lat));
            //     }, 100);
            // }
        },
        getUserMessageReminderAlarm() {
            this.$request({
                method: 'post',
                url: '/ubi/api/advanceAlarm/userMessageReminderAlarm',
                data: {}
            }).then((res) => {
                if (res.code == 200) {
                    let msgData = res.data;
                    this.msgSum = 0;
                    for (const key in msgData) {
                        this.msgSum += msgData[key].length;
                    }

                    this.msgTypeData = this.msgTypeData.map((item) => ({
                        ...item,
                        msgDataLength: (msgData[item.value] && msgData[item.value].length) || 0
                    }));
                    setTimeout(() => {
                        this.getUserMessageReminderAlarm();
                    }, 60000 * 5);
                } else {
                    console.log('热力图获取失败');
                }
            });
        },
        noticeDetail(type) {
            const targetItem = this.msgTypeData.find((item) => item.key === type);
            this.$router.push({
                path: '/notice/index', // 路由名称
                query: { msgType: targetItem.value, noticeType: targetItem.key } // 路由参数
            });
        },
        //操作修改密码
        handleEditPassword() {
            if (this.form.newPassword != this.form.newPassword2) {
                this.$message.error('抱歉，您两次输入的新密码不一致');
                return false;
            }
            var json = {
                oldPassword: this.form.oldPassword,
                newPassword: this.form.newPassword
            };
            this.instance.post('/upms/api/user/changePassword', json).then((res) => {
                var data = res.data;
                // this.$message(data.message)
                if (data.code === 200) {
                    this.centerDialogVisible = false;
                    this.$confirm('密码修改成功，请重新登录。', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        // cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            this.$router.replace({
                                path: '/'
                            });
                        })
                        .catch(() => {
                            this.$router.replace({
                                path: '/'
                            });
                        });
                    // this.$router.replace({path:'/'});
                } else {
                    this.$message.error(data.message);
                }
            });
        },
        //操作退出
        handleLogOut() {
            this.$confirm('此操作将退出当前登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    localStorage.clear();
                    sessionStorage.clear();
                    this.$router.replace({
                        path: '/'
                    });
                    location.reload();
                    this.$message({
                        type: 'success',
                        message: '退出成功!'
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        handleMenu(item, clickMenu) {
            this.activeMenuId = item.menuId;
            if (localStorage.getItem('headerMenus')) {
                this.menusObj = JSON.parse(localStorage.getItem('menusObj'));
            }

            localStorage.setItem('checkedMenu', JSON.stringify(this.menusObj[item.name]));
            localStorage.setItem('checkedMenuId', this.activeMenuId);
            this.$emit('clickMenu', this.menusObj[item.name]);
            if (!clickMenu) {
                localStorage.setItem('jumpPath', item.linkage);
                this.dataCollection(buildMenuTrackingPayload({ menu: item, path: item.linkage, source: 'top' }));
                this.$router.push({ path: item.linkage }, () => {});
            }
        },
        //点击面包屑，是否展开菜单
        handleFoldMenus(isFold) {
            this.isFold = isFold;
            this.$emit('handleFoldMenus', isFold);
        },
        sreamStartPlay(playData) {
            let clientId = playData.deviceNumber;
            const streamOrigin = baseURL.replace(/\/manager$/, '');
            this.videoList[playData.channelNo - 1].url = streamOrigin + '/video/0' + clientId + '-' + playData.channelNo;
            this.videoList[playData.channelNo - 1].deviceNumber = clientId;

            setTimeout(() => {
                let tmpRefEl = this.$refs['mediaHeaderRef' + (playData.channelNo - 1)];

                if (!playData.playFlag) {
                    if (tmpRefEl && tmpRefEl.length > 0) {
                        this.$refs['mediaHeaderRef' + (playData.channelNo - 1)][0].startPlay();
                    } else if (tmpRefEl) {
                        this.$refs['mediaHeaderRef' + (playData.channelNo - 1)][0].startPlay();
                    }
                } else {
                    let tmpItem = JSON.parse(JSON.stringify(this.videoList[playData.channelNo - 1]));
                    tmpItem.stopFlag = false;
                    tmpItem.play = true;
                    tmpItem.loading = false;
                    tmpItem.pause = false;

                    this.videoList[playData.channelNo - 1] = null;
                    this.videoList[playData.channelNo - 1] = tmpItem;
                    this.$forceUpdate();

                    if (tmpRefEl && tmpRefEl.length > 0) {
                        this.$refs['mediaHeaderRef' + (playData.channelNo - 1)][0].rePlay();
                    } else if (tmpRefEl) {
                        this.$refs['mediaHeaderRef' + (playData.channelNo - 1)][0].rePlay();
                    }
                }
            }, 100);

            this['countdown' + playData.channelNo] = setTimeout(() => {
                // console.log('停止播放');
                this.sreamEnd(playData.channelNo);
            }, 60000);
        },
        clearPlayTime() {
            // console.log('清延迟器');
            clearTimeout(this.countdown1);
            clearTimeout(this.countdown2);
        },
        closePlayer(channelNo) {
            clearTimeout(this['countdown' + channelNo]);
            if (this.$refs['mediaHeaderRef' + (channelNo - 1)]) {
                this.$refs['mediaHeaderRef' + (channelNo - 1)][0].cancelSubscription();
            }
        },
        sreamStart(playData) {
            this.instance.post('/ubi/api/advance_device/realtimeStreamStart', { clientId: playData.deviceNumber, channelNo: playData.channelNo }).then((res) => {
                if (res.code == 200) {
                    const streamData = res.data && res.data.data ? res.data.data : res.data;
                    if (streamData && streamData.code == 4000) {
                        this.$message.error(streamData.msg);
                        return;
                    }

                    const clientId = streamData && streamData.clientId ? streamData.clientId : playData.deviceNumber;
                    const streamOrigin = baseURL.replace(/\/manager$/, '');
                    this.videoList[playData.channelNo - 1].url = streamOrigin + '/video/0' + clientId + '-' + playData.channelNo;
                    this.videoList[playData.channelNo - 1].deviceNumber = clientId;

                    // console.log('channelNo:' + playData.channelNo);
                    let tmpRefEl = this.$refs['mediaHeaderRef' + (playData.channelNo - 1)];

                    if (!playData.playFlag) {
                        if (tmpRefEl && tmpRefEl.length > 0) {
                            this.$refs['mediaHeaderRef' + (playData.channelNo - 1)][0].startPlay();
                        } else if (tmpRefEl) {
                            this.$refs['mediaHeaderRef' + (playData.channelNo - 1)][0].startPlay();
                        }
                    } else {
                        let tmpItem = JSON.parse(JSON.stringify(this.videoList[playData.channelNo - 1]));
                        tmpItem.stopFlag = false;
                        tmpItem.play = true;
                        tmpItem.loading = false;
                        tmpItem.pause = false;

                        this.videoList[playData.channelNo - 1] = null;
                        this.videoList[playData.channelNo - 1] = tmpItem;
                        this.$forceUpdate();

                        if (tmpRefEl && tmpRefEl.length > 0) {
                            this.$refs['mediaHeaderRef' + (playData.channelNo - 1)][0].rePlay();
                        } else if (tmpRefEl) {
                            this.$refs['mediaHeaderRef' + (playData.channelNo - 1)][0].rePlay();
                        }
                    }

                    this['countdown' + playData.channelNo] = setTimeout(() => {
                        // console.log('停止播放');
                        this.sreamEnd(playData.channelNo);
                    }, 60000);
                }
            });
        },
        sreamEnd(channelNo) {
            // console.log('header end');
            this.instance.post('/ubi/api/advance_device/realtimeStreamEnd', { clientId: this.currentDeviceNumber, channelNo: channelNo }).then((res) => {
                this.closePlayer(channelNo);

                if (res.code == 200) {
                    this.videoList[channelNo - 1].stopFlag = true;
                    this.videoList[channelNo - 1].play = false;
                    this.videoList[channelNo - 1].loading = false;
                    this.videoList[channelNo - 1].pause = false;
                    let tmpItem = JSON.parse(JSON.stringify(this.videoList[channelNo - 1]));
                    this.videoList[channelNo - 1] = null;
                    this.videoList[channelNo - 1] = tmpItem;
                    this.$forceUpdate();
                } else {
                    console.log(res.data);
                }
            });
        },
        closePolice() {
            this.clearPlayTime();
            if (this.pageStatus && this.$refs.mediaHeaderRef0 && this.$refs.mediaHeaderRef0[0]) {
                this.$refs.mediaHeaderRef0[0].cancelSubscription();
                this.$refs.mediaHeaderRef1[0].cancelSubscription();
            }
        },
        showWarningDialog(closePoliceFlag) {
            var delIndexArr = [];
            for (const key in this.warningObj) {
                this.warningList.forEach((item, index) => {
                    if (item.alarm_id == key) {
                        delIndexArr.push(index);
                    }
                });
            }

            if (delIndexArr.length > 0) {
                console.log('需要关闭的告警索引');
                console.log(delIndexArr);
                var tmpDeviceNumber = this.warningList[0] ? this.warningList[0].device_number : null;
                for (var i = delIndexArr.length - 1; i >= 0; i--) {
                    var indexToDelete = delIndexArr[i];
                    this.warningList.splice(indexToDelete, 1);
                }

                // console.log('告警列表:' + closePoliceFlag);
                // console.log(this.warningList);
                if (this.warningList.length == 0) {
                    this.policeVisible = false;
                    return;
                    // setTimeout(() => {
                    //     this.$emit('videoMapPlay');
                    // }, 2000);
                }
            }

            if (this.warningList.length > 0 && !this.policeVisible && this.pageStatus) {
                console.log('告警弹窗数据：');
                console.log(this.warningList);

                this.openDialogFlag = true;
                this.warningData = this.warningList[0];
                this.policeVisible = true;
                this.currentDeviceNumber = this.warningData.device_number;

                // console.log(this.$route.path);
                // console.log('关闭地图页面');

                this.$emit('destroyMapPlay');
                // this.$emit('canMapPlay');

                // this.sreamStartPlay({ deviceNumber: this.currentDeviceNumber, channelNo: 1, playFlag: this.openDialogFlag });
                // this.sreamStartPlay({ deviceNumber: this.currentDeviceNumber, channelNo: 2, playFlag: this.openDialogFlag });

                // console.log('start warning ');
                this.sreamStart({ deviceNumber: this.currentDeviceNumber, channelNo: 1, playFlag: this.openDialogFlag });
                this.sreamStart({ deviceNumber: this.currentDeviceNumber, channelNo: 2, playFlag: this.openDialogFlag });
            }
        },
        closeWarning() {
            this.$refs.mediaHeaderRef0[0].cancelSubscription();
            this.$refs.mediaHeaderRef1[0].cancelSubscription();
            this.instance.post('/ubi/api/emergency_alarm/close', { alarmId: this.warningData.alarm_id, clientId: this.currentDeviceNumber }).then((res) => {
                this.clearPlayTime();

                if (res.code == 200) {
                    this.policeVisible = false;
                    this.currentDeviceNumber = null;
                    this.warningData = {};
                    let pathStr = this.$route.path;
                    if (pathStr == '/devices/warningList') {
                        let btnEl = document.querySelectorAll('.queryBtn');
                        btnEl[0] && btnEl[0].click();
                    }
                    setTimeout(() => {
                        this.showWarningDialog(true);
                    }, 1000);
                }
            });
        },
        handleVisibilityChange() {
            if (document.visibilityState == 'hidden') {
                this.closePolice();
                this.pageStatus = 0;
                this.policeVisible = false;
            } else if (document.visibilityState == 'visible') {
                this.pageStatus = 1;
                this.showWarningDialog();
            }
        },
        onmessageWS(event) {
            let _this = this;
            switch (event.type) {
                case 'onmessageWS':
                    let msgData = event.detail.data;
                    console.log('onmessageWS-----------------------');
                    console.log(msgData);

                    if (msgData.alarm_id) {
                        if (msgData.alarm_status) {
                            _this.warningObj[msgData.alarm_id] = msgData;
                        } else {
                            const isExist = _this.warningList.find((item) => item.alarm_id === msgData.alarm_id);

                            !isExist && _this.warningList.push(msgData);
                        }
                        _this.showWarningDialog();
                    }

                    break;
            }
        }
    },
    mounted() {
        this.$websocket.close();
        this.warningObj = {};
        this.$nextTick(() => {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        });
        this.activeMenuId = localStorage.getItem('checkedMenuId') ? localStorage.getItem('checkedMenuId') : '2';
        let tmpPath = this.$route.path;
        let tmpPathArr = tmpPath.split('/');
        let tmpClickItem = null;
        let _this = this;
        if (!localStorage.getItem('headerMenus')) {
            let routesTimer = setInterval(() => {
                if (JSON.parse(localStorage.getItem('routes'))) {
                    clearInterval(routesTimer);
                    let tmpMenus = [];
                    let tmpRoutes = JSON.parse(localStorage.getItem('routes')) || [];
                    let tmpItem = {};
                    let tmpMenusObj = {};
                    tmpRoutes.forEach((ele) => {
                        if (ele.children && ele.children.length > 0) {
                            tmpItem = {
                                menuId: ele.meta.menuId,
                                name: ele.meta.title,
                                linkage: ele.path + '/' + ele.children[0].path,
                                parentPath: ele.path
                            };
                            tmpMenus.push(tmpItem);
                            if (tmpPathArr.length > 0 && ele.name == tmpPathArr[1]) {
                                this.activeMenuId = ele.meta.menuId;
                                tmpClickItem = tmpItem;
                            }
                        } else if (ele.meta && !ele.meta.showHidden) {
                            tmpItem = {
                                menuId: ele.meta.menuId,
                                name: ele.meta.title,
                                linkage: ele.path,
                                parentPath: ele.path
                            };
                            tmpMenus.push(tmpItem);
                        }
                        ele.meta ? (this.menusObj[ele.meta.title] = ele) : '';
                        ele.meta ? (tmpMenusObj[ele.meta.title] = ele) : '';
                    });
                    this.menus = tmpMenus;
                    tmpClickItem && this.handleMenu(tmpClickItem, true);
                    localStorage.setItem('headerMenus', JSON.stringify(tmpMenus));
                    localStorage.setItem('menusObj', JSON.stringify(tmpMenusObj));
                }
            }, 100);
        } else {
            this.menus = JSON.parse(localStorage.getItem('headerMenus'));
            this.menus.forEach((item) => {
                if (tmpPathArr.length > 0 && item.parentPath.slice(1, item.parentPath.length) == tmpPathArr[1]) {
                    this.activeMenuId = item.menuId;
                    tmpClickItem = item;
                }
            });
            tmpClickItem && this.handleMenu(tmpClickItem, true);
        }

        window.addEventListener('onmessageWS', this.onmessageWS);

        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        this.queryUserProduct();
        // this.getUserMessageReminderAlarm();
    },
    computed: {
        userInfoData() {
            return this.$store.state.common.userInfoData;
        }
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('onmessageWS', this.onmessageWS);
    }
};
</script>
<style lang="less" scoped>
.headerPage {
    width: 100%;
    height: 60px;
    padding: 0 30px 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #262d3c;
    color: #ffffff;
    .header_left {
        width: 26rem;
        justify-content: flex-start;
        .decoration_box {
            display: flex;
            align-items: center;
            .header_logo {
                width: 150px;
                margin-left: -20px;
                margin-right: 20px;
            }
        }
        .fold_icon {
            i {
                font-size: 26px;
                cursor: pointer;
            }
        }
    }
    .header_right {
        min-width: 4rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .header_logo {
            width: 135px;
            margin-right: 20px;
            margin-top: 5px;
        }
        .msgIcon {
            width: 0.2rem;
            height: 0.24rem;
            background: url(../../public/images/home/msg.png) no-repeat;
            background-size: 100% 100%;
            position: relative;
            top: 2px;
            cursor: pointer;
            color: transparent;
        }
        .msgHot::before {
            content: '';
            display: inline-block;
            width: 7px;
            height: 7px;
            background: red;
            position: absolute;
            top: -1px;
            right: -2px;
            border-radius: 50%;
        }
        .userinfo {
            display: flex;
            align-items: center;
            .nickname {
                font-size: 0.21rem;
                font-family: cursive;
                margin-left: 0.2rem;
                margin-top: 4px;
            }
            .user_picture {
                width: 40px;
                height: 40px;
            }
        }
        .el-dropdown {
            color: #fff;
            cursor: pointer;
        }
    }
}

/deep/.el-dialog--center .el-dialog__body {
    padding: 25px 80px 30px;
}
/deep/ .el-dropdown {
    font-size: 16px;
}
.menus {
    font-size: 0.2rem;
    li {
        margin-left: 0.4rem;
        cursor: pointer;
    }
    li:hover {
        color: #30fbfe;
        font-weight: 500;
    }
    .active {
        color: #30fbfe;
        font-weight: 500;
    }
}

// 紧急告警
.policeDialog {
    /deep/ .el-dialog__body {
        padding: 20px 22px;
    }
}

.policeBox {
    .box_left,
    .box_right {
        width: 420px;
        margin-right: 5px;
    }
}
.product-update {
    width: 100%;
    height: 100vh;
    background: rgba(255, 255, 255, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .productTitle {
        margin-top: 150px;
        text-align: center;
        color: #333;
        font-size: 40px;
        letter-spacing: 14px;
    }
    .product-box {
        display: flex;
        justify-content: space-evenly;
        color: #333;
        margin-top: 50px;
        .list {
            width: 28%;
            // border: 1px solid red;
            p {
                font-size: 20px;
                text-align: center;
                margin-top: 15px;
            }
        }
    }
    .closeBtn {
        cursor: pointer;
        font-weight: 700;
        cursor: pointer;
        font-size: 40px;
        position: relative;
        left: 50%;
        color: #262d3c;
        transform: translateX(-50%);
        margin-top: 40px;
    }
}
</style>
